// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1355":"f0e091a7cf075ae1","1513":"09e945be6c4119a2","4976":"2bff880f7222fb29","6012":"dcf2129a1fbd6edc","7003":"edd0a7b7860fd269"}[chunkId] + ".js";
};